<script>
  import { APP_CONSTANTS } from '../../../common/config/app-constants';

  export let code;
</script>

<div class="product-360-view-container">
  <!-- svelte-ignore a11y-missing-attribute -->
  <object
    class="product-image-360"
    type="text/html"
    data={APP_CONSTANTS.IMAGE_360_VIEW_BASE_URL.replace('productSku', code)}
  ></object>
</div>

<style lang="scss">
  @import './../../common/styles/colors.new.scss';

  .product-360-view-container {
    width: 100%;
    display: block;
    background: $primary-white;
    padding-bottom: 0px;
    .product-image-360 {
      display: block;
      height: 334px;
      width: 100%;
      min-width: 0;
      margin: 0;
    }
    @include desktop-min-width {
      background: $primary-black;
      // padding-bottom: 96px;
      .product-image-360 {
        width: 100%;
        min-width: 0;
        height: 480px;
        min-height: 480px;
        margin: 0;
        border-radius: 20px;
      }
    }
  }
</style>
